// src/routes/statistics/report/AutoDownload.js

import React, { useCallback, useEffect, useState } from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import { format } from 'date-fns';
import { useSelector } from 'react-redux';
import './GenDaily.css';

import { downloadCsvFile } from './utils/csvDownload';
import { fetchAndBuildDailyGeneration } from './services/dailyGenerationService';
import { notifyAutoCsvDownloadSettingsChange } from './components/AutoCsvDownloadManager';

import DownloadSection from './components/DownloadSection';
import LoadingToast from './components/LoadingToast';

const AutoDownload = () => {
  const ivList = useSelector((state) => state.Iv_list);
  const Ev_list = useSelector((state) => state.Ev_list || {});

  const [manualDownloadDate, setManualDownloadDate] = useState(new Date());
  const [isDownloading, setIsDownloading] = useState(false);

  const [autoDownloadTime, setAutoDownloadTime] = useState(() => {
    const saved = localStorage.getItem('autoDownloadTime');
    return saved || '18:00';
  });

  const [autoDownloadEnabled, setAutoDownloadEnabled] = useState(() => {
    const saved = localStorage.getItem('autoDownloadEnabled');
    return saved === 'true';
  });

  useEffect(() => {
    localStorage.setItem('autoDownloadTime', autoDownloadTime);
    notifyAutoCsvDownloadSettingsChange();
  }, [autoDownloadTime]);

  useEffect(() => {
    localStorage.setItem('autoDownloadEnabled', autoDownloadEnabled.toString());
    notifyAutoCsvDownloadSettingsChange();
  }, [autoDownloadEnabled]);

  const totalCapacity = (ivList?.iv_capa || []).reduce(
    (sum, capa) => sum + (Number(capa) || 0),
    0
  );

  const fetchAndBuild = useCallback(
    async ({ start, end, mode }) => {
      return await fetchAndBuildDailyGeneration({
        start,
        end,
        mode,
        ivList,
        Ev_list,
        totalCapacity,
      });
    },
    [ivList, Ev_list, totalCapacity]
  );

  const handleManualDownload = useCallback(async () => {
    setIsDownloading(true);
    try {
      const d = manualDownloadDate;
      const dateStr = format(d, 'yyyy-MM-dd');

      const { csv } = await fetchAndBuild({
        start: d,
        end: d,
        mode: 'individual',
      });

      const ok = downloadCsvFile(csv, `태양광발전데이터_${dateStr}.csv`);
      if (!ok) throw new Error('CSV 생성/다운로드 실패');
    } catch (e) {
      console.error('[수동 CSV 다운로드] 실패:', e);
      alert(`CSV 다운로드 실패: ${e.message}`);
    } finally {
      setIsDownloading(false);
    }
  }, [manualDownloadDate, fetchAndBuild]);

  return (
    <div className="gen-daily-page">
      <LoadingToast visible={isDownloading} />

      <DownloadSection
        autoDownloadEnabled={autoDownloadEnabled}
        setAutoDownloadEnabled={setAutoDownloadEnabled}
        autoDownloadTime={autoDownloadTime}
        setAutoDownloadTime={setAutoDownloadTime}
        manualDownloadDate={manualDownloadDate}
        setManualDownloadDate={setManualDownloadDate}
        handleManualDownload={handleManualDownload}
        isDownloading={isDownloading}
      />
    </div>
  );
};

export default AutoDownload;
